export default __webpack_public_path__ + "static/media/video.81db53ed.svg";